export default "__VITE_ASSET__BLjgOzAQ__"